import { lenis } from "./modules/lenis.js";
import { init as headerInit } from "./modules/header.js";
import { init as aboutMeInit } from "../../blocks/about-me/index.js";
import { init as servicesInit } from "../../blocks/services/index.js";
import { init as faqInit } from "../../blocks/faq/index.js";
import { init as heroInit } from "../../blocks/hero/hero.js";
import { init as counterInit } from "../../blocks/counter/counter.js";

const interceptTurnstile = () => {
    if (window.turnstile && typeof window.turnstile.render === 'function' && !window.turnstile.render.isIntercepted) {
        const originalRender = window.turnstile.render;
        window.turnstile.render = function(container, options) {
            const widgetId = originalRender.call(this, container, options);
            const el = typeof container === 'string' ? document.querySelector(container) : container;
            if (el) {
                el.dataset.turnstileWidgetId = widgetId;
            }
            return widgetId;
        };
        window.turnstile.render.isIntercepted = true;
    }
};

// Set up a getter/setter to intercept if Turnstile loads after this script
if (typeof window !== 'undefined') {
    let _turnstile = window.turnstile;
    Object.defineProperty(window, 'turnstile', {
        configurable: true,
        enumerable: true,
        get() {
            return _turnstile;
        },
        set(val) {
            _turnstile = val;
            if (val && typeof val.render === 'function' && !val.render.isIntercepted) {
                const originalRender = val.render;
                val.render = function(container, options) {
                    const widgetId = originalRender.call(this, container, options);
                    const el = typeof container === 'string' ? document.querySelector(container) : container;
                    if (el) {
                        el.dataset.turnstileWidgetId = widgetId;
                    }
                    return widgetId;
                };
                val.render.isIntercepted = true;
            }
        }
    });
    if (_turnstile) {
        window.turnstile = _turnstile;
    }
}

const init = async () => {
    headerInit();
    aboutMeInit();
    servicesInit();
    faqInit();
    heroInit();
    counterInit();

    // Intercept Turnstile render to capture widget IDs for cleanup
    interceptTurnstile();

    // Reinitialize Contact Form 7
    if (typeof wpcf7 !== 'undefined' && typeof wpcf7.init === 'function') {
        document.querySelectorAll('.wpcf7 > form, .wpcf7-form').forEach((form) => {
            wpcf7.init(form);
        });
    }

    // Reinitialize Cloudflare Turnstile explicitly since the plugin uses explicit rendering mode
    if (window.turnstile && typeof window.turnstile.render === 'function') {
        document.querySelectorAll('.cf-turnstile').forEach((el) => {
            if (!el.innerHTML.trim()) {
                try {
                    const widgetId = window.turnstile.render(el);
                    el.dataset.turnstileWidgetId = widgetId;
                } catch (err) {
                    console.warn('Turnstile render failed:', err);
                }
            }
        });
    }

    if (lenis) {
        lenis.start();
    }
};

export { init };
